import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import classNames from "classnames";
import { useWindowSize } from "react-use";
import { demoPagesMenu } from "../../menu";
import {
  DropdownItem,
  DropdownMenu,
} from "../../components/bootstrap/Dropdown";
import Button from "../../components/bootstrap/Button";
import useDarkMode from "../../hooks/useDarkMode";
import Collapse from "../../components/bootstrap/Collapse";
import { NavigationLine } from "../Navigation/Navigation";
import Icon from "../../components/icon/Icon";
import useNavigationItemHandle from "../../hooks/useNavigationItemHandle";
import AuthContext from "../../contexts/authContext";
import ThemeContext from "../../contexts/themeContext";
import axios from "axios";
import apiConfig from "../../pages/auth/apiConfig";
import profileImage from "../../assets/profile.svg";
import { useParams } from "react-router-dom";

const User = () => {
  const { width } = useWindowSize();
  const { setAsideStatus } = useContext(ThemeContext);
  const { userData, setUser } = useContext(AuthContext);
  const [profileImageUrl, setProfileImageUrl] = useState<string | null>(null);

  const navigate = useNavigate();
  const handleItem = useNavigationItemHandle();

  const authToken = localStorage.getItem("authToken");

  const [collapseStatus, setCollapseStatus] = useState<boolean>(false);
  const [profile, setProfile] = useState<any>(null);
  const { id } = useParams<{ id: string }>();

  useEffect(() => {
    fetchProfile();
  }, []);

  const fetchProfile = async () => {
    try {
      const userId = localStorage.getItem("userId");

      if (!userId) {
        throw new Error("User ID is not found in local storage");
      }

      const response = await axios.get(
        `${apiConfig.apiBaseURL}/users/getProfile/${userId}`,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
            "Content-Type": "application/json",
          },
        }
      );

      const profileData = response.data.user;
      if (profileData.profileUrl) {
        let formattedUrl = profileData.profileUrl;
        if (!formattedUrl.startsWith(apiConfig.apiBaseURL)) {
          formattedUrl = `${apiConfig.apiBaseURL}/uploads/${formattedUrl
            .split("\\")
            .pop()}`;
        }
        setProfileImageUrl(formattedUrl);
      } else {
        setProfileImageUrl(null);
      }
      setProfile(profileData);
    } catch (error) {
      console.error("Error fetching profile", error);
    }
  };
  const truncateName = (name: any) => {
    if (!name) return '';
    return name.length > 14 ? `${name.slice(0, 14)}...` : name;
  };
  
  return (
    <div
      className={classNames("user ")}
      role="presentation"
      onClick={() => {
        navigate("/profile");
      }}
      style={{
        backgroundColor: "#3C6DB2",
        padding: "1.3rem 1rem",
      }}
    >
      <div className="user-avatar">
        <img
          srcSet={profile?.srcSet}
          src={profileImageUrl ? profileImageUrl : profileImage}
          alt="Avatar"
          style={{ width: "4.5rem", height: "4.5rem" }}
        />
      </div>
      <div className="user-info">
        <div className="user-name d-flex align-items-center">
        {truncateName(profile?.name)}
          <Icon icon="Verified" className="ms-1" color="info" />
        </div>
        <div className="user-sub-title" style={{ color: "white" }}>
          {profile?.roleId === 1 && (
            <span style={{ fontSize: "1.2em" }}>Super Admin</span>
          )}
          {profile?.roleId === 2 && (
            <span style={{ fontSize: "1.2em" }}>Super User</span>
          )}
          {profile?.roleId === 3 && (
            <span style={{ fontSize: "1.2em" }}>Group Merchant Admin</span>
          )}
          {profile?.roleId === 4 && (
            <span style={{ fontSize: "1.2em" }}>Group Merchant Supervisor</span>
          )}
          {profile?.roleId === 5 && (
            <span style={{ fontSize: "1.2em" }}>Group Merchant User</span>
          )}
          {profile?.roleId === 6 && (
            <span style={{ fontSize: "1.2em" }}>Sub Merchant Admin</span>
          )}
          {profile?.roleId === 7 && (
            <span style={{ fontSize: "1.2em" }}>Sub Merchant Supervisor</span>
          )}
          {profile?.roleId === 8 && (
            <span style={{ fontSize: "1.2em" }}>Sub Merchant User</span>
          )}
        </div>
      </div>
    </div>
  );
};

export default User;
